import { useState } from 'react';

// Persist only notification identities, scoped to the signed-in user.
export default function useNotificationDismissals(user) {
  const identity = user?.userId ?? user?.id ?? user?.username ?? user?.userName;
  const key = identity == null ? null : `notification-dismissals:v1:${user?.groupId ?? ''}:${identity}`;
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key));
      return Array.isArray(value) ? value.filter(item => typeof item === 'string') : [];
    } catch { return []; }
  };
  const [state, setState] = useState(() => ({ key, value: key ? read() : [] }));
  const value = state.key === key ? state.value : (key ? read() : []);
  const dismiss = identities => {
    setState(previous => {
      const current = previous.key === key ? previous.value : (key ? read() : []);
      const next = [...new Set([...current, ...identities])].slice(-2000);
      if (key) {
        try { localStorage.setItem(key, JSON.stringify(next)); } catch { /* Memory fallback when storage is unavailable. */ }
      }
      return { key, value: next };
    });
  };
  return [value, dismiss];
}
